module.exports = __webpack_public_path__ + "static/media/waves2.5a1683dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/backgrounds/waves2.png
// module id = 186
// module chunks = 0